<template>
  <v-app>
    <div class="text-xs-center">
      <v-dialog
        v-model="$wait.any"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ $t('wait') }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import AuthenticationService from './services/AuthenticationService'

export default {
  name: 'App',

  created () {
    this.checkSession()
  },

  onActive () {
    this.checkSession()
  },

  methods: {
    checkSession () {
      AuthenticationService.refreshSession()
      if (!AuthenticationService.isUserLoggedIn()) {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.input-group--text-field input {
  border-bottom: 1px solid #2c3e50
}
</style>



// WEBPACK FOOTER //
// src/App.vue